module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"JavascriptRequired":{"heading":"Máte vypnutý javascript!","text":"Pro plnou funkčnost těchto stránek je nutné povolit JavaScript. Zde jsou {link}.","linkText":"instrukce jak povolit JavaScript ve Vašem webovém prohlížeči"}}}')
  delete Component.options._Ctor
}
